var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#278B9F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_12177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 17.0008H25.21L20.82 10.4308C20.42 9.84078 19.55 9.84078 19.16 10.4308L14.77 17.0008H10C9.45 17.0008 9 17.4508 9 18.0008C9 18.0908 9.01 18.1808 9.04 18.2708L11.58 27.5408C11.81 28.3808 12.58 29.0008 13.5 29.0008H26.5C27.42 29.0008 28.19 28.3808 28.43 27.5408L30.97 18.2708L31 18.0008C31 17.4508 30.55 17.0008 30 17.0008ZM19.99 12.7908L22.8 17.0008H17.18L19.99 12.7908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6482 22.1318C17.5504 22.0278 17.4155 21.9666 17.2728 21.9616C17.1302 21.9565 16.9913 22.0079 16.8863 22.1047C16.7814 22.2015 16.7189 22.3359 16.7125 22.4785C16.706 22.6211 16.7562 22.7605 16.852 22.8663L18.8085 24.9891C19.0993 25.274 19.5327 25.274 19.8019 25.0054L19.999 24.8109C20.7111 24.1107 21.4223 23.4096 22.1327 22.7076L22.1543 22.686C22.8182 22.0317 23.4787 21.3739 24.1357 20.7127C24.2339 20.6099 24.2878 20.4726 24.2856 20.3304C24.2835 20.1883 24.2256 20.0526 24.1243 19.9528C24.0231 19.853 23.8867 19.797 23.7445 19.7969C23.6023 19.7968 23.4658 19.8525 23.3644 19.9522C22.7104 20.6099 22.0532 21.2645 21.3927 21.9157L21.3711 21.9374C20.6903 22.6103 20.0088 23.2823 19.3263 23.9535L17.6482 22.1318Z",
    fill: "#278B9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_12177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveProduct);
export default __webpack_public_path__ + "static/media/removeProduct.ad979a2cea1540995019ddd551dc5729.svg";
export { ForwardRef as ReactComponent };